import * as React from 'react'
import { IconProps } from './types'

export const TimelineDot = ({ title, ...rest }: IconProps) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
    <title>{title || ''}</title>
    <circle cx='8' cy='8' r='8' fill='#D5D6D9' />
  </svg>
)
